import Vue, { defineAsyncComponent } from 'vue'
import Vuex from 'vuex'
import { State } from './entities/State'
import { Course } from './entities/Course'
import { User } from '@/entities/User'
import { CourseBooking } from '@/entities/CourseBooking'
import { Appointment } from '@/entities/Appointment'

Vue.use(Vuex)

const stateBase: State = {
  courses: [],
  users: [],
  appointments: [],
  courseBookings: [],
  currentUserEmail: '',
  selectedAppointments: []
}

export default new Vuex.Store<State>({
  state: stateBase,
  mutations: {
    resetState (state:State) {
      state.appointments.splice(0)
      state.users.splice(0)
      state.courseBookings.splice(0)
      state.selectedAppointments.splice(0)
    },
    setCurrentUserEmail (state:State, currentUserEmail:string) {
      state.currentUserEmail = currentUserEmail
    },
    addCourseBooking (state:State, courseBooking:CourseBooking) {
      state.courseBookings.push(courseBooking)
    },
    addUser (state:State, user:User) {
      state.users.push(user)
    },
    updateCourseBookingPaid (state:State, courseID:number) {
      const courseBooking: CourseBooking | undefined = state.courseBookings.find(courseBooking => courseBooking.id === courseID)

      courseBooking!.setPaid(true)
    },
    toggleAppointment (state:State, appointmentId:number) {
      const index = state.selectedAppointments.findIndex(appointment => appointment.id === appointmentId)
      if (index === -1) {
        const appointment:Appointment | undefined = state.appointments.find(appointment => appointment.id === appointmentId)
        state.selectedAppointments.push(<Appointment>appointment)
      } else {
        state.selectedAppointments.splice(index, 1)
      }
    },
    updateAppointmentList (state:State, appointments:Appointment[]) {
      state.appointments.push(...appointments)
    },
    updateCoursesList (state:State, course:Course) {
      if (!state.courses.includes(course)) {
        state.courses.push(course)
      }
    },
    updateCoursesBookingList (state:State, courseBooking:CourseBooking) {
      state.courseBookings.push(courseBooking)
    }
  },
  actions: {},
  getters: {
    getCourses: (state) => (page:number, pageSize:number) => {
      return state.courses.slice((page - 1) * pageSize, page * pageSize)
    },
    getCouseById: (state:State) => (courseId:number) => {
      return state.courses.find(course => course.id === courseId)
    },
    getCourseByName: (state:State) => (courseName:string) => {
      return state.courses.find(course => course.name === courseName)
    },
    getAppointmentsByCourseId: (state:State) => (courseId:number, page:number, pageSize:number) => {
      return state.appointments.filter(appointment => appointment.courseId === courseId).slice((page - 1) * pageSize, page * pageSize)
    },
    getPaidCourseBookingByAppointmentId: (state:State) => (appointmnetId:number) => {
      return state.courseBookings.filter(courseBooking => courseBooking.appointmentId === appointmnetId && courseBooking.paid === true)
    },
    getIsSelectedAppointment: (state:State) => (appointmentId:number) => {
      return state.selectedAppointments.some(appointment => appointment.id === appointmentId)
    },
    getSelectedAppointments: (state:State) => () => {
      return state.selectedAppointments
    },
    getAppointmentById: (state:State) => (appointmentId:number) => {
      return state.appointments.find(appointment => appointment.id === appointmentId)
    }
  }
})
